import JSZip from 'jszip';
import { ARCHIVE_MAX_BYTES, ARCHIVE_MAX_FILES, ARCHIVE_POLICY, csvCell, sha256 } from './certificate-retention';

// Sin persistencia: un error en cualquier original invalida el lote completo.
export async function buildCertificateArchive(rows, download, onProgress = () => {}) {
  if (!rows.length || rows.length > ARCHIVE_MAX_FILES) throw new Error('Seleccioná entre 1 y 50 certificados por lote.');
  if (new Set(rows.map((row) => row.certificate_id)).size !== rows.length) throw new Error('Hay certificados duplicados.');
  const batchId = crypto.randomUUID();
  const zip = new JSZip();
  const manifest = [];
  let bytes = 0;
  for (const row of rows) {
    if (!row.certificate_id || !row.storage_path || row.storage_deleted_at) throw new Error('Hay un certificado sin original disponible.');
    if (Number(row.file_bytes) > ARCHIVE_MAX_BYTES - bytes) throw new Error('El lote supera 128 MiB. Seleccioná menos certificados.');
    onProgress(`Descargando ${manifest.length + 1} de ${rows.length}…`);
    const blob = await download(row.storage_path);
    if (!blob || !blob.size) throw new Error(`El certificado ${row.certificate_number} está vacío o no pudo descargarse.`);
    bytes += blob.size;
    if (bytes > ARCHIVE_MAX_BYTES) throw new Error('El lote supera 128 MiB. Seleccioná menos certificados.');
    const data = await blob.arrayBuffer();
    const header = new TextDecoder().decode(data.slice(0, 1024));
    if (!header.includes('%PDF-')) throw new Error(`El original ${row.certificate_number} no parece un PDF válido.`);
    const hash = await sha256(data);
    if ((row.sha256 && row.sha256 !== hash) || (row.file_bytes != null && Number(row.file_bytes) !== blob.size)) {
      throw new Error(`El original ${row.certificate_number} cambió. Se bloqueó la exportación; solicitá revisión.`);
    }
    const name = `${String(row.certificate_number || 'certificado').replace(/[^a-zA-Z0-9_-]/g, '_')}-${row.certificate_id}.pdf`;
    const item = {
      certificate_id: row.certificate_id, certificate_number: row.certificate_number,
      client_id: row.client_id, client_name: row.client_name, instrument_id: row.instrument_id,
      service_order_code: row.service_order_code, certificate_status: row.certificate_status,
      issued_at: row.retention_started_at, approved_at: row.approved_at,
      storage_path: row.storage_path, filename: `certificados/${name}`, bytes: blob.size, sha256: hash,
    };
    manifest.push(item);
    zip.file(item.filename, data);
  }
  const columns = ['certificate_number','certificate_id','client_name','service_order_code','certificate_status','issued_at','filename','bytes','sha256'];
  zip.file('indice.csv', '\uFEFF' + [columns.map(csvCell).join(';'), ...manifest.map((row) => columns.map((key) => csvCell(row[key])).join(';'))].join('\r\n'));
  zip.file('manifiesto.json', JSON.stringify({ batch_id: batchId, policy: ARCHIVE_POLICY, files: manifest }, null, 2));
  zip.file('LEEME.txt', 'CALINS — Archivo de certificados\nSubir este ZIP sin modificar a Drive institucional. Descargarlo desde Drive y seleccionarlo en Archivo de certificados para comprobar su integridad.\nUna descarga local no confirma el archivo maestro. Conservar el PDF original y todas sus versiones.\n');
  onProgress('Preparando ZIP y comprobando integridad…');
  const data = await zip.generateAsync({ type: 'uint8array', compression: 'STORE' });
  const zipHash = await sha256(data);
  return { batchId, manifest, zipHash, blob: new Blob([data], { type: 'application/zip' }), filename: `CALINS-certificados-${batchId}.zip` };
}

export async function verifyRecoveredArchive(file, batch) {
  if (!file || Number(batch.zip_bytes) !== file.size) throw new Error('El tamaño del ZIP no coincide. No se confirmó ningún certificado.');
  const hash = await sha256(file);
  if (hash !== batch.zip_sha256) throw new Error('El ZIP recuperado no es idéntico al exportado. No se confirmó ningún certificado.');
  return hash;
}
